import React, { useEffect, memo } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import {
  setIsSuccessResporePassword,
  getIsSuccessResporePassword,
} from 'redux/reducers/profile'
import { useShallowEqualSelector } from 'custom-hooks'
import CircleCheck from 'components/CommonUI/svgIcons/CircleCheck'

const SuccessRestorePassword = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const isSuccessRestorePassword = useShallowEqualSelector(
    getIsSuccessResporePassword
  )

  useEffect(() => {
    let timeout
    if (isSuccessRestorePassword) {
      timeout = setTimeout(() => {
        dispatch(setIsSuccessResporePassword(false))
      }, 5000)
    } else {
      history.push('/')
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [dispatch, history, isSuccessRestorePassword])

  return (
    <div className="success_page_container">
      <CircleCheck />
      <h3 className="success_page_text">
        New password successfully has been set!
      </h3>
    </div>
  )
}

export default memo(SuccessRestorePassword)
